const DITypes = {
  JsonRpcDispatcher: Symbol('CfrFinsightStratsJsonRpcDispatcher'),
  DispatcherFactory: Symbol('CfrFinsightStratsDispatcherFactory'),
  AdapterFactory: Symbol('CfrFinsightStratsAdapterFactory'),
};

export default DITypes;
